"use client";

import { useState } from "react";
import { Button } from "./ui/button";
import { formatInAppTz } from "../utils/timezone";

export const BartenderTipDeleteModal = ({ 
  isOpen, 
  onClose, 
  record, 
  onDelete 
}) => {
  const [deleting, setDeleting] = useState(false);
  
  const handleDelete = async () => {
    if (!record) return;
    
    setDeleting(true);
    const success = await onDelete();
    setDeleting(false);
    
    if (success) {
      onClose();
    }
  };
  
  if (!isOpen || !record) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Are you sure?</h2>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            &times;
          </button>
        </div>
        
        <p className="mb-6">
          This action cannot be undone. Are you sure you want to delete this floor tip record?
        </p>
        
        <div className="bg-gray-100 p-4 rounded-md mb-6">
          <p><span className="font-medium">Date:</span> {formatInAppTz(record.date)}</p>
          <p><span className="font-medium">Employee:</span> {record.employee}</p>
          <p><span className="font-medium">Tips Received:</span> ${parseFloat(record.tip_out_cash || 0).toFixed(2)}</p>
          <p><span className="font-medium">Tax:</span> ${parseFloat(record.tax || 0).toFixed(2)}</p>
          <p><span className="font-medium">Added By:</span> {record.added_by}</p>
        </div>
        
        <div className="flex justify-center space-x-4">
          <Button
            variant="outline"
            onClick={onClose}
          >
            No
          </Button>
          <Button
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600 text-white"
            disabled={deleting}
          >
            {deleting ? "Deleting..." : "Yes, Delete"}
          </Button>
        </div>
      </div>
    </div>
  );
};